/* GENERATED BY DECAFFEINATE */
/* globals EventUiManager, BoostModel */

// Instant Event Notifications
//
// Instantiating one of these suckers adds the markup and triggers the appearing
// animation for a site-wide slide-up notification. Requires the following data
// pack to properly display:
//
// {
//   person: {
//	 screenname (required): "Michael"
//	 thumbnail (either a full path, or...): "http://i3.kym-cdn.com/photos/images/newsfeed/000/243/561/afc.gif"
//	 thumb (...image name of the user's thumbnail)
//   }
//   eventtype (required): a class-safe string describing the event
//   infostring (required): a description of the event
//   link (optional): Link that clicking the notification goes to.
// }

import GlobalMessaging from "features/global_messaging";
import {
	templateStringToElement,
} from "shared/util/query_util";

class EventNotification {
	static onClickMessageOrbitNotification(event) {
		event.preventDefault();
		const clickedEl = event.target;
		const userid = clickedEl.dataset.userid;

		if (!userid) {
			return false;
		}

		// Try to open a conversation with this user.
		GlobalMessaging.openConversation(userid);

		// Get list of visible notifications (if available).
		// Explicitly choosing not to use an import here,
		// To avoid loading this bundle where it's not applicable.
		const visibleNotificationList = EventUiManager
			? EventUiManager.notifications
			: [];

		// Close the notification
		// (Loop through the ui manager to find the right one)
		Array.from(visibleNotificationList).forEach((notification) => {
			// Ignore non-message notifications.
			if (notification.eventtype !== "msg_notify") return;

			// Ignore notifications that aren't for this user.
			if (notification.person.userid !== userid) return;

			// Close the notification.
			notification.close();
		});

		return false;
	}

	constructor(params) {
		this.person = params.person;
		this.eventtype = params.eventtype;
		this.title = params.title ? params.title : "";
		this.infostring = params.infostring ? params.infostring : "";
		this.link = params.link ? params.link : "";

		this.el = null;
		this.shown = false;
		this.closeTimer = null;

		if (params.id) {
			this.el = document.getElementById(params.id);
			this.listen();
		} else {
			this.el = null;
			this.make();
		}

		if (this.isBoostUp()) {
			const eventcontainer = document.getElementById("event_display_body");
			eventcontainer.scrollTop = 0;
		}
	}

	// make and show the notification
	make() {
		let link;

		if (this.person.thumbnail == null && this.person.thumb != null) {
			this.person.thumbnail = EventUiManager.getThumbUrl(this.person.thumb);
		}

		if (this.link) {
			({ link } = this);
		} else if (this.person.link !== undefined) {
			link = this.person.link;
		} else {
			link = `/profile/${this.person.screenname}?cf=event`;
		}

		this.el = this.createEventEl({
			screenname: this.person.screenname,
			displayname: this.person.displayname,
			thumbnail: this.person.thumbnail,
			link,
			eventtype: this.eventtype,
			title: this.title,
			infostring: this.infostring,
			orbit_class: "dispelled",
			userid: this.person.userid,
			onclick: this.eventtype === "msg_notify"
				? "window.EventNotification.onClickMessageOrbitNotification(event)"
				: "",
		});

		const eventDisplayBody = document.getElementById("event_display_body");

		if (eventDisplayBody) {
			eventDisplayBody.insertBefore(this.el, eventDisplayBody.firstChild);
		}

		// remove the hide class so the shit slides up
		this.el.classList.remove("dispelled");

		this.listen();

		// if spotlight is on, notify the user
		if (this.isBoostUp()) {
			this.el.classList.add("new");

			setTimeout(() => {
				this.el.classList.remove("new");
			}, 15000);
		}
	}

	listen() {
		this.shown = true;

		if (!this.el) return;

		const closeEl = this.el.querySelector(".close");
		closeEl.addEventListener("onclick,ontap", () => {
			return this.close();
		});

		this.closeSoon();
	}

	isBoostUp() {
		const state =
			typeof BoostModel !== "undefined" && BoostModel !== null
				? BoostModel.get("state")
				: undefined;
		return state === "running" || state === "reporting";
	}

	closeSoon() {
		if (this.isBoostUp()) {
			return;
		}

		if (typeof BoostModel !== "undefined" && BoostModel !== null) {
			if (BoostModel.state === "running" || BoostModel.state === "reporting") {
				return;
			}
		}

		// like tears in rain
		if (!this.shown) {
			return;
		}

		clearTimeout(this.closeTimer);

		this.closeTimer = setTimeout(() => {
			this.close();
		}, EventUiManager.m_event_display_time);
	}

	close(closehard) {
		EventUiManager.pauseMessages();
		this.shown = false;

		if (!this.el) return;

		if (this.el.classList.contains("dispelled")) {
			return;
		}

		if (closehard) {
			this.el.classList.add("dispelled_hard");
		}

		EventUiManager.m_event_count -= 1;

		const footerEl = document.getElementById("im_footer");

		if (EventUiManager.m_event_count <= 0) {
			footerEl.classList.add("remove_last_notification");

			setTimeout(() => {
				footerEl.classList.remove("hasnotifications");
				footerEl.classList.remove("remove_last_notification");
				this.el.classList.add("dispelled");
			}, 500);
		} else {
			this.el.classList.add("dispelled");
		}
	}

	createEventEl(event) {
		// this must stay in sync with /okcontent/components/event_notification.html
		const template = `
			<div id="notification_${event.eventtype}_${event.screenname || event.displayname}" class="orbit_event ${event.orbit_class}">
				<div class="orbit_inner">

					<span class="indicator"></span>

					<img src="${event.thumbnail}" />

					<div class="info">
						<div class="user">
							${event.title || event.displayname || event.screenname}
						</div>
						<div class="action">
							${event.infostring}
						</div>
					</div>

					<a href="${event.link}"
							class="event_link"
							onclick="${event.onclick}"
							data-userid="${event.userid}"
							data-eventtype="${event.type || event.eventtype}"></a>
					<a href="javascript:void(0)" class="close">
						<span class="icon i-close"></span>
					</a>

				</div>
			</div>
		`.trim();

		return templateStringToElement(template);
	}
}

window.EventNotification = EventNotification;
export default EventNotification;



// WEBPACK FOOTER //
// ./src/shared/util/EventNotification.js